import * as yup from "yup";
export const valSchemaLogin = yup.object().shape({
    login: yup.string().typeError('This field accepts only text').required("Login is required"),
    password: yup.string().typeError('This field accepts only text').required('This field is required').min(6, 'The field must be at least 6 characters long'),
});

export const validationSchemaEmail = yup.object().shape({
    email: yup.string().email('Invalid email format').required("Email is required"),
});
